import React, { Component } from "react";
import { withRouter } from "../utils/withRouter";
import api from "../api/index";
import fulllogo from "../assets/images/spare_logo_full.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

class MerchantPassword extends Component {
  constructor(props) {
    super(props);
    const { id, access_token, reset_token } = this.props.params;

    this.state = {
      id,
      access_token,
      reset_token,
      newPassword: "",
      isSubmitting: false,
      message: "",
      error: "",
      showPassword: false
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { id, access_token, reset_token, newPassword } = this.state;

    this.setState({ isSubmitting: true, error: "", message: "" });

    fetch(`${api.main}api/agent/set_merchant_password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, access_token, reset_token, password: newPassword }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Reset link is invalid or expired.");
        return res.json();
      })
      .then(() => {
        this.setState({
          message: "Password has been reset. Redirecting to login...",
        });
        setTimeout(() => this.props.navigate("/"), 2500);
      })
      .catch((err) =>
        this.setState({
          error: err.message,
          isSubmitting: false,
        })
      );
  };

  render() {
    const newPassword = this.state.newPassword;
    return (
      <div className="login-form">
        <img src={fulllogo} alt="Logo" style={{ width: "200px" }} />
        <h2>Set Your Password</h2>
        <form onSubmit={this.handleSubmit}>
          <div className="login-items" style={{flexDirection: "column"}}>
            <div className="password-wrapper">
                <input
                    type={this.state.showPassword ? "text" : "password"}
                    placeholder="New Password"
                    value={this.state.newPassword}
                    onChange={(e) => this.setState({ newPassword: e.target.value })}
                    onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                    }}
                    className="password-input"
                    required
                />
                <FontAwesomeIcon
                    icon={this.state.showPassword ? faEyeSlash : faEye}
                    className="toggle-visibility"
                    onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                />
            </div>
            {newPassword && newPassword.length < 8 && (
                <small className="text-warning">Password must be at least 8 characters</small>
            )}
        </div>
          <div className="login-items">
            <button
              className="btn btn-primary"
              type="submit"
              style={{ width: "200px" }}
              disabled={this.state.isSubmitting || newPassword.length < 8}
            >
              {this.state.isSubmitting ? "Resetting..." : "Set Password"}
            </button>
          </div>
        </form>
        {this.state.message && <p className="success">{this.state.message}</p>}
        {this.state.error && <p className="error-text">{this.state.error}</p>}
      </div>
    );
  }
}

export default withRouter(MerchantPassword);
